import { render, staticRenderFns } from "./ModalOrderCancel.vue?vue&type=template&id=6bf712cc&scoped=true&"
import script from "./ModalOrderCancel.vue?vue&type=script&lang=js&"
export * from "./ModalOrderCancel.vue?vue&type=script&lang=js&"
import style0 from "./ModalOrderCancel.vue?vue&type=style&index=0&id=6bf712cc&prod&lang=scss&"
import style1 from "./ModalOrderCancel.vue?vue&type=style&index=1&id=6bf712cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf712cc",
  null
  
)

export default component.exports